




































// TODO написать интерфейсы для defaultLayout
import Header from './header/Header.vue';
import Footer from './footer/Footer.vue';
import SpecialSections from '@/uikit/components/AppDefaultLayout/specialSections/SpecialSections.vue';
import AuthPopups from '@/uikit/components/AppDefaultLayout/specialContents/authPopups/AuthPopups.vue';
import ModalDefault from '@/components/modal/default';
import ExtButton from '@/components/ext/Button.vue';
import ModalEssia from '@/components/modalEssia/ModalEssia.vue';
export default {
  components: {
    AuthPopups,
    SpecialSections,
    Header,
    Footer,
    ModalDefault,
    ModalEssia,
    ExtButton,
  },
  data() {
    return {
      specialPages: ['start-page', 'new-error-404'],
      submitDataEsia: {},
      isMount: false,
      errors: [],
    };
  },
  methods: {
    closeEssiaModal() {
      this.$router.push('');
    },
    async acceptModal() {
      try {
        this.submitDataEsia.$v.$touch();
        if (this.submitDataEsia.$v.$invalid) {
          if (typeof this.fillErrors === 'function') {
            this.fillErrors();
          }
          return;
        }
        await this.$store.dispatch(
          'user/essia_signin_new',
          this.submitDataEsia.submitData
        );
        this.$router.push({ name: 'profile-favorite' });
        this.$toast.success('Успешно!');
      } catch (err) {
        if (err.errors && Array.isArray(err.errors)) {
          this.errors = err.errors;
        }
        this.$toast.error(
          err.message ? err.message : 'Ошибка отправки данных!'
        );
      }
    },
  },
  mounted() {
    this.isMount = true;
    const {
      hasEsiaAuth,
      $route: {
        query: { xEsiaCode },
      },
    } = this;
    this.$nextTick(() => {
      if (this.$store.state.isTokensExist) {
        this.$store.dispatch('user/init');
      }
    });
    if (hasEsiaAuth) {
      const savedUrl = localStorage.getItem('pageUrl');
      if (xEsiaCode && xEsiaCode.length) {
        this.$store
          .dispatch('user/esiaSignup', xEsiaCode)
          .then(({ municipality_id, redirect_url }) => {
            if (redirect_url) {
              const splitten = redirect_url.split('?');
              this.$router.push(`/?${splitten[1]}${splitten[0].split('/')[1]}`);
            } else if (municipality_id === '0' || !municipality_id) {
              this.$router.push({ name: 'profile-settings-address' });
            } else if (savedUrl) {
              this.$router.push(JSON.parse(savedUrl), () => {
                localStorage.removeItem('pageUrl');
              });
            } else {
              this.$router.push({ query: null });
            }
          })
          .catch((error) => {
            this.$router.push({ query: null, hash: 'entrance' });
          });
      }
    }
  },
  computed: {
    hasEsiaAuth() {
      return this.$store.getters.hasApiModuleEsia;
    },
    defaultLayout() {
      return this.$store.state.defaultLayout;
    },
    isModalAuth() {
      return this.routeHash.split('?')[0] === 'esia_form' && this.isMount;
    },
    routeHash() {
      return this.$route.hash ? this.$route.hash.substring(1) : '';
    },
    mainPage() {
      if (!this.specialPages.includes(this.$route.name)) return {};
      return {
        layoutSpecialContentConfig: this.defaultLayout.config.content,
        layoutDataSet: this.defaultLayout.dataSet,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/AppDefaultLayout.vue